import { useState, useEffect } from 'react';

const useChatbotPrompt = (checkInQuery, inputPrompts) => {
    const [prompts, setPrompts] = useState([]);

    useEffect(() => {
        if (checkInQuery.isFetched) {
            setPrompts(inputPrompts);
        }
    }, [checkInQuery.isFetched]);

    return prompts;
};

export { useChatbotPrompt };
